"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var Variables_1 = require("../../Variables");
var ChevronRight_1 = __importDefault(require("../../Icon/icons/ChevronRight"));
var ContentStepper_1 = __importStar(require("../../ContentStepper/ContentStepper"));
var MobileMenuHeader_1 = __importDefault(require("../../MobileMenuHeader/MobileMenuHeader"));
var MainMenuWrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: ", ";\n  color: ", ";\n  height: 100vh;\n  left: 0;\n  margin-left: -100vw;\n  position: fixed;\n  top: 0;\n  transition: margin-left 0.25s ease-in-out;\n  width: 100vw;\n  z-index: 1;\n  ", "\n"], ["\n  background-color: ", ";\n  color: ", ";\n  height: 100vh;\n  left: 0;\n  margin-left: -100vw;\n  position: fixed;\n  top: 0;\n  transition: margin-left 0.25s ease-in-out;\n  width: 100vw;\n  z-index: 1;\n  ", "\n"])), Variables_1.color.BRAND_BLUE, Variables_1.color.BRAND_WHITE, function (props) { return "margin-left: ".concat(props.$open ? "0" : "-100vw", ";"); });
var MobileMenuPageWrapper = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  max-height: 100vh;\n  width: 100%;\n"], ["\n  display: flex;\n  flex-direction: column;\n  max-height: 100vh;\n  width: 100%;\n"])));
var MobileMenuItems = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  overflow-y: auto;\n"], ["\n  overflow-y: auto;\n"])));
var MobileMenuItem = styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  align-items: center;\n  display: flex;\n  padding: ", ";\n"], ["\n  align-items: center;\n  display: flex;\n  padding: ", ";\n"])), Variables_1.padding.MD);
var MobileMenuItemTitle = styled_components_1.default.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  flex-grow: 1;\n"], ["\n  flex-grow: 1;\n"])));
var MobileMenuItemNav = styled_components_1.default.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  align-items: center;\n  display: flex;\n  flex-shrink: 0;\n  justify-content: center;\n  width: 24px;\n"], ["\n  align-items: center;\n  display: flex;\n  flex-shrink: 0;\n  justify-content: center;\n  width: 24px;\n"])));
var MainMenuMobile = function (_a) {
    var mainMenu = _a.mainMenu, mainMenuTop = _a.mainMenuTop, onClose = _a.onClose, onMainMenuChange = _a.onMainMenuChange, title = _a.title;
    var _b = React.useState(false), open = _b[0], setOpen = _b[1];
    var startPage = {
        isRoot: true,
        subItems: mainMenu,
        title: title,
        url: undefined,
    };
    var AnimateBeforeClose = function () {
        setOpen(false);
        var lastTime;
        requestAnimationFrame(function animation(time) {
            if (!lastTime)
                lastTime = time;
            if (time - lastTime < 250) {
                requestAnimationFrame(animation);
                return;
            }
            onClose === null || onClose === void 0 ? void 0 : onClose();
        });
    };
    React.useEffect(function () {
        setOpen(true);
    }, []);
    return (React.createElement(MainMenuWrapper, { "$open": open },
        React.createElement(ContentStepper_1.default, null,
            React.createElement(MainMenuMobilePage, { mainMenuTop: mainMenuTop, onClose: AnimateBeforeClose, onMainMenuChange: onMainMenuChange, page: startPage }))));
};
exports.default = MainMenuMobile;
var MainMenuMobilePage = function (_a) {
    var mainMenuTop = _a.mainMenuTop, onClose = _a.onClose, onMainMenuChange = _a.onMainMenuChange, page = _a.page;
    var subItems = page.subItems, title = page.title;
    return (React.createElement(ContentStepper_1.ContentStepperContext.Consumer, null, function (_a) {
        var toggleBack = _a.toggleBack, toggleNext = _a.toggleNext;
        return (React.createElement(MobileMenuPageWrapper, null,
            React.createElement(MobileMenuHeader_1.default, __assign({ color: "BRAND_WHITE", onCloseClick: onClose }, (!page.isRoot && {
                onBackClick: toggleBack,
            }), { title: title })),
            mainMenuTop &&
                React.cloneElement(mainMenuTop, __assign(__assign({}, mainMenuTop.props), { onClose: onClose })),
            React.createElement(MobileMenuItems, null, subItems === null || subItems === void 0 ? void 0 : subItems.map(function (item) {
                var _a;
                return (React.createElement(MobileMenuItem, { key: "menuItem-".concat(item.title) },
                    React.createElement(MobileMenuItemTitle, __assign({}, (item.url && {
                        onClick: function () {
                            onMainMenuChange(item);
                            onClose === null || onClose === void 0 ? void 0 : onClose();
                        },
                    })), item.title),
                    Boolean((_a = item.subItems) === null || _a === void 0 ? void 0 : _a.length) && (React.createElement(MobileMenuItemNav, { onClick: function () {
                            return toggleNext === null || toggleNext === void 0 ? void 0 : toggleNext(React.createElement(MainMenuMobilePage, { onClose: onClose, onMainMenuChange: onMainMenuChange, page: item }));
                        } },
                        React.createElement(ChevronRight_1.default, null)))));
            }))));
    }));
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
